import { Component, Input } from 'ng-metadata/core';
import './loader.component.scss';

/**
 * @ngdoc directive
 * @name mwLoader
 * @module mw.components.loader
 *
 * @description
 * `<mw-loader>` is a component used to display a Meltwater loading indicator.
 *
 * By default, the loader color is setup for light backgrounds.  If you need to show it over a dark background, use one of the following classes
 * - `md-loader--white`
 * - `md-loader--dark`
 *
 * @usage
 * <hljs hljs-language="html">
 *   <!-- The mw-loader will be center positioned to the closest parent element with relative or absolute positioning -->
 *   <div style="position:relative">
 *      <mw-loader></mw-loader>
 *   </div>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-loader',
    template: `
        <div class="mw-loader">
            <div class="mw-loader__drop"></div>
            <div class="mw-loader__circle1"></div>
            <div class="mw-loader__circle2"></div>
        </div>
    `
})
export class LoaderComponent {
    constructor () {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/loader/loader.component.ts